import React from 'react';
import './index.css';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import * as ROUTES from './constants/routes';
import DesktopPage from './pages/desktop';
import MobilePage from './pages/mobile';

function detectMob() {
	const toMatch = [
		/Android/i,
		/webOS/i,
		/iPhone/i,
		/iPad/i,
		/iPod/i,
		/BlackBerry/i,
		/Windows Phone/i,
	];

	return toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem));
}

const App = () => (
	<Router>
		<Route exact path="/">
			{detectMob() ? <Redirect to={ROUTES.MOBILE} /> : <Redirect to={ROUTES.DESKTOP} />}
		</Route>
		<Route exact path={ROUTES.DESKTOP} component={DesktopPage} />
		<Route path={`${ROUTES.DESKTOP}/:roomId`} component={DesktopPage} />
		<Route exact path={ROUTES.MOBILE} component={MobilePage} />
		<Route path={`${ROUTES.MOBILE}/:roomId`} component={MobilePage} />
	</Router>
);

export default App;
